module.exports = "<h2 style=\"color: white;\">{{ params.key | translate }}</h2>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/no-content/forbidden.html
// module id = 75
// module chunks = 3